import { initMercadoPago } from '@mercadopago/sdk-react';
import { EVENTO_ATUAL, getLoteAtivo, precoDoIngresso, type Lote } from '../config/event';

const isLocalhost = window.location.hostname === 'localhost';
const publicKey = isLocalhost 
    ? 'APP_USR-15904e90-1afa-4d2b-93a1-9bd1b81f8498' 
    : 'APP_USR-6ec19449-dd11-4bdc-8649-c7a7b0fbccda';

initMercadoPago(publicKey, { locale: 'pt-BR' });

// Lote ativo no momento (virada automática por data, America/Sao_Paulo).
// Manter sincronizado com o backend (generatepdf.py LOTES_MITOLOGIA_2026).
export const getLoteCorrente = (now: Date = new Date()): Lote => getLoteAtivo(now);

// Compat: preço da inteira do lote vigente (antes: TICKET_VALUE fixo).
export const TICKET_VALUE = getLoteCorrente().inteira;
export const HALF_TICKET_VALUE = getLoteCorrente().meia;

export const calculateTotalValue = (ticketHolders: any[], lote?: Lote): number => {
    const ativo = lote || getLoteCorrente();
    return ticketHolders.reduce((total, ticket) => {
        return total + precoDoIngresso(ticket.ticketType, ativo);
    }, 0);
};

// Normaliza e-mail (case-insensitive): evita duplicidade no banco/S3 e
// rejeição aparente no Brick por caixa alta (autocapitalize do iOS).
export const normalizeEmail = (email: any): string =>
    String(email || '').trim().toLowerCase();

// E-mail do titular (primeiro ingresso) — alimenta o Brick via `payer`
// para o comprador não precisar redigitar no Pix/cartão.
export const getTitularEmail = (ticketHolders: any[]): string =>
    normalizeEmail(ticketHolders?.[0]?.email);

export const getInitialization = (ticketHolders: any[], lote?: Lote) => {
    const payerEmail = getTitularEmail(ticketHolders);
    return {
        amount: calculateTotalValue(ticketHolders, lote),
        // Brick pré-preenche o e-mail do pagador (Pix e cartão). Sem isso,
        // autofill do Safari/iOS preenche visualmente sem registrar o estado
        // interno do Brick → "Dado obrigatório" com campo aparentemente cheio.
        ...(payerEmail ? { payer: { email: payerEmail } } : {}),
    };
};

export const customization = {
    paymentMethods: {
        bankTransfer: "all",
        creditCard: "all",
        mercadoPago: ["all"],
    },
};

export const onSubmit = async (
    { formData }: { formData: any },
    param: any,
    onSuccess: () => void
): Promise<{ qr_code: string; qr_code_base64: string }> => {
    console.log(formData);
    console.log(param);
    const lote = getLoteCorrente();
    return new Promise((resolve, reject) => {
        fetch("https://ta3m3foyci.execute-api.sa-east-1.amazonaws.com/ingressos", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                evento_id: EVENTO_ATUAL,
                lote_id: lote.id,
                formData: formData.map((item: any) => ({
                    nome: item.name,
                    documento: item.documentNumber,
                    email: normalizeEmail(item.email),
                    telefone: item.cellNumber,
                    tipo_ingresso: item.ticketType,
                    comprovanteNumero: item.comprovanteNumber
                })),
                param: param,
                value: calculateTotalValue(formData, lote),
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("Pagamento bem-sucedido");
                onSuccess(); // Call the success callback
                resolve({
                    qr_code: data.qr_code,
                    qr_code_base64: data.qr_code_base64
                });
            })
            .catch(() => {
                console.log("Erro ao processar o pagamento");
                reject();
            });
    });
};

export const onError = async (error: any) => {
    // callback chamado para todos os casos de erro do Brick
    console.log(error);
};

export const onReady = async () => {
    /*
      Callback chamado quando o Brick estiver pronto.
      Aqui você pode ocultar loadings do seu site, por exemplo.
    */
    console.log("Payment Brick is ready");
};